module.exports = __webpack_public_path__ + "img/icon_delete.32f950c1.svg";